/**
 * Shared pipeline-vs-regular decision for `/projectDetails/:matterId`.
 *
 * MatterDetails is the single front door (regular typed engineering projects AND converted bids).
 * SiblingRouteGuard uses the same marks and the same query key so a sibling URL cannot
 * disagree with the screen the front door would have opened.
 */
export const pipelineRouteQueryKey = (matterId: string) =>
  ['ProjectDetailRoute', matterId] as const;

export function isPipelineMatter(detail?: {
  mattertype?: string;
  bid_id?: string | null;
} | null): boolean {
  return detail?.mattertype === 'Pipeline Construction' || Boolean(detail?.bid_id);
}
